import {requestHeader, request} from './api';

export const get = () => {
    return requestHeader(`/admin/segment`, {
        method: 'GET',
    });
};

export const create = (segment) => {
    return request(`/admin/segment`, {
        method: 'POST',
        body: JSON.stringify(segment),
    });
};

export const update = (segment) => {
    return request(`/admin/segment`, {
        method: 'PUT',
        body: JSON.stringify(segment),
    });
};

export const getById = (id) => {
    return request(`/admin/segment/${id}`, {
        method: 'GET',
    });
};

export const remove = (id) => {
    return request(`/admin/segment/${id}`, {
        method: 'DELETE',
    });
};
 
export default {get}